import i18n from 'i18next';

export const generateStepId = () => {
    return Math.round(Math.random() * 100000);
};

export const initalizeStepsData = (type: string, steps: string[], baseIndex?: number) => {
    return steps.map((text: string, index: number) => ({
        id: generateStepId(),
        step: index + 1 + (baseIndex ? baseIndex : 0),
        status: "template",
        approval_date: text ? "-" : "",
        text: text,
        type: text ? type : "",
        currency_type: text ? i18n.t("fiat_string") : "",
        currency: text ? "-" : "",
        quantity: text ? "-" : "",
        price: text ? "-" : "",
        total: text ? "-" : "",
        actions: null,
        editable: null
    }))
};

export const initializeDepositData = (coins?: any[]) => {
    const data: any[] = initalizeStepsData(i18n.t("deposits_string"), ["NIS", "NIS ⇄ EUR", "EUR ⇄ USD", ""]);
    if (coins) {
        coins.forEach((coin: any) => {
            data.push({
                id: coin.coin,
                step: null,
                status: "template",
                approval_date: "-",
                type: i18n.t("buy_string"),
                text: coin.coin + " ⇄ USD",
                currency_type: i18n.t("crypto_string"),
                currency: "USD",
                quantity: "-",
                price: "-",
                total: "-",
            });
        });
    }
    return data;
};